import Alert from './Alert/Alert';
import Badge from './Badge';
import Button from './Button/Button';
import Checkbox from './Checkbox';
import Drawer from './Drawer';
import Form from './Form';
import FormLabel from './FormLabel';
import Heading from './Heading';
import Input from './Input';
import Link from './Link';
import Menu from './Menu';
import Modal from './Modal';
import PinInput from './PinInput';
import Popover from './Popover';
import Radio from './Radio';
import Select from './Select';
import Skeleton from './Skeleton';
import Spinner from './Spinner';
import Switch from './Switch';
import Table from './Table';
import Tabs from './Tabs';
import Tag from './Tag/Tag';
import Text from './Text';
import Textarea from './Textarea';
import Tooltip from './Tooltip/Tooltip';

const components = {
  Alert,
  Badge,
  Button,
  Checkbox,
  Drawer,
  Heading,
  Input,
  Form,
  FormLabel,
  Link,
  Menu,
  Modal,
  PinInput,
  Popover,
  Radio,
  Select,
  Skeleton,
  Spinner,
  Switch,
  Tabs,
  Table,
  Tag,
  Text,
  Textarea,
  Tooltip,
};

export default components;
